import React from 'react';
import { ListCheckbox } from 'react-toolbox/lib/list'

const Checkbox = ({isChecked, key, value, onClick, label}) => {
    return (
        <ListCheckbox
            checked={isChecked}
            key={key}
            caption={label}
            onChange={() => onClick(value)}
        />
    )
}

export default (Checkbox)